import { Trans, useTranslation } from 'react-i18next';
import LegalLayout from './LegalLayout';
import useSeo from '../../seo/useSeo';

// 개인정보 처리방침 — 토이플(Toyple) / Lansly
// 포트원(코리아포트원)·Polar 를 결제 처리 수탁자로 명시하는 것이 핵심(제5조 위탁 표).
export default function Privacy() {
  const { t } = useTranslation('legal');
  useSeo({ page: 'privacy', path: '/privacy' });
  const list = (key) => t(key, { returnObjects: true });

  return (
    <LegalLayout>
      <h1 className="legal-title">{t('privacy.title')}</h1>
      <p className="legal-meta">
        {t('privacy.effectiveLabel')}: {t('biz.docDate')} · {t('privacy.announcedLabel')}:{' '}
        {t('biz.docDate')}
      </p>
      <p className="legal-intro">{t('privacy.intro')}</p>

      <section className="legal-section">
        <h2>{t('privacy.art1Title')}</h2>
        <p>{t('privacy.art1Intro')}</p>
        <ul>
          {list('privacy.art1Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art2Title')}</h2>
        <h3>{t('privacy.art2Sub1Title')}</h3>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                {list('privacy.art2Head').map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {list('privacy.art2Rows').map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <h3>{t('privacy.art2Sub2Title')}</h3>
        <ul>
          {list('privacy.art2Sub2Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art3Title')}</h2>
        <ol>
          {list('privacy.art3Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                {list('privacy.art3Head').map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {list('privacy.art3Rows').map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art4Title')}</h2>
        {/* 두 개의 문단을 하나의 키에 \n\n 으로 묶고 pre-line 으로 렌더링 */}
        <p className="legal-multiline">{t('privacy.art4Body')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art5Title')}</h2>
        <div className="legal-highlight">
          <p>
            <Trans t={t} i18nKey="privacy.art5Highlight" components={{ strong: <strong /> }} />
          </p>
        </div>
        <div className="legal-table-wrap">
          <table className="legal-table">
            <thead>
              <tr>
                {list('privacy.art5Head').map((h, i) => (
                  <th key={i}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {list('privacy.art5Rows').map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p>{t('privacy.art5Note')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art6Title')}</h2>
        <p>{t('privacy.art6Body')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art7Title')}</h2>
        <ol>
          {list('privacy.art7Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art8Title')}</h2>
        <ol>
          {list('privacy.art8Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art9Title')}</h2>
        <p>{t('privacy.art9Intro')}</p>
        <ul>
          {list('privacy.art9Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art10Title')}</h2>
        <ol>
          {list('privacy.art10Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art11Title')}</h2>
        <p>{t('privacy.art11Body')}</p>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art12Title')}</h2>
        <p>{t('privacy.art12Body')}</p>
        <div className="legal-info-box" style={{ marginTop: 16 }}>
          <dl>
            <dt>{t('privacy.art12PmLabel')}</dt>
            <dd>백경인 ({t('privacy.art12PmRoleCeo')})</dd>
            <dt>{t('privacy.art12EmailLabel')}</dt>
            <dd>admin@toyple.net</dd>
            <dt>{t('privacy.art12PhoneLabel')}</dt>
            <dd>+82-10-8515-1619</dd>
          </dl>
        </div>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art13Title')}</h2>
        <p>{t('privacy.art13Intro')}</p>
        <ul>
          {list('privacy.art13Items').map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="legal-section">
        <h2>{t('privacy.art14Title')}</h2>
        <p>{t('privacy.art14Body')}</p>
      </section>

      <div className="legal-info-box">
        <h2>{t('biz.heading')}</h2>
        <dl>
          <dt>{t('biz.companyLabel')}</dt>
          <dd>토이플(Toyple)</dd>
          <dt>{t('biz.ceoLabel')}</dt>
          <dd>백경인</dd>
          <dt>{t('biz.regNoLabel')}</dt>
          <dd>601-55-00778</dd>
          <dt>{t('biz.mailOrderLabel')}</dt>
          <dd>2025-서울강동-0817</dd>
          <dt>{t('biz.addressLabel')}</dt>
          <dd>서울특별시 강동구 성내동 37-48, 2동 302호</dd>
          <dt>{t('biz.emailLabel')}</dt>
          <dd>admin@toyple.net</dd>
        </dl>
      </div>
    </LegalLayout>
  );
}
